/** Mirrors node_ageshield/defaults/ageTemplateDefaults.js — client-side defaults & merges */

/** Inner popup content panel only (not the dimmed store overlay). 0–100, default fully opaque. */
export const DEFAULT_POPUP_BACKGROUND_OPACITY = 100;

/** Dimmed store overlay behind the popup modal. 0–100. */
export const DEFAULT_POPUP_OUTER_OPACITY = 60;

export const DEFAULT_AGE_TEMPLATE_CONFIG = {
  version: 1,
  popupEnabled: true,
  checkoutEnabled: false,
  /** Shared minimum age for popup and checkout (mirrored into each slice on save). */
  ageRule: { minAge: 18 },
  popup: {
    layout: "4",
    verificationMethod: "no_input",
    /**
     * When true (default): under-age / failed checks block closing the popup and do not record verified.
     * When false: completing the step closes the popup and records verification (relaxed — e.g. analytics only).
     */
    restrictVerification: true,
    verifyAge: 18,
    dob: {
      dateFormat: "DD_MM_YYYY_SLASH",
      dateOrder: "DD,MM,YY",
      errorMessage:
        "You must be {{minimum_age}} or older. Please enter a valid date.",
    },
    confirmCheckbox: {
      enabled: false,
      label: "I confirm I am {{minimum_age}}+",
      font: "'Inter', sans-serif",
      weight: "400",
      size: "15px",
      color: "#111827",
    },
    popupShow: { mode: "every_time", cookieDays: 30 },
    text: {
      title: {
        text: "Welcome!",
        font: "'Inter', sans-serif",
        weight: "700",
        size: "35px",
        color: "#111827",
      },
      description: {
        text: "Please verify that you are {{minimum_age}} years of age or older to enter this site.",
        font: "'Inter', sans-serif",
        weight: "400",
        size: "16px",
        color: "#4B5563",
      },
    },
    buttons: {
      accept: {
        text: "Yes, I am {{minimum_age}}+",
        borderRadius: 8,
        borderWidth: 1,
        weight: "600",
        font: "'Inter', sans-serif",
        size: "16px",
        color: "#FFFFFF",
        background: "#111827",
        borderColor: "#111827",
      },
      reject: {
        text: "No, I am under {{minimum_age}}",
        borderRadius: 8,
        borderWidth: 1,
        weight: "600",
        font: "'Inter', sans-serif",
        size: "16px",
        color: "#111827",
        background: "#F3F4F6",
        borderColor: "#E5E7EB",
        redirectUrl: "",
      },
    },
    popupStyle: {
      animation: "fade",
      height: "auto",
      width: 600,
      paddingY: 24,
      paddingX: 24,
      backgroundColor: "#FFFFFF",
      backgroundOpacity: DEFAULT_POPUP_BACKGROUND_OPACITY,
      backgroundImageEnabled: false,
      backgroundImageUrl: "",
      borderWidth: 0,
      borderRadius: 12,
      borderColor: "#E5E7EB",
      outerColor: "#000000",
      outerOpacity: DEFAULT_POPUP_OUTER_OPACITY,
      outerImageEnabled: false,
      outerImageUrl: "",
    },
    logo: { show: false, square: false, url: "" },
    displayCriteria: {
      mode: "all_pages",
      triggerCondition: "always",
      urls: [],
      productHandles: "",
      productTags: "",
      collectionHandles: "",
      selectedProducts: [],
      selectedCollections: [],
    },
    privacy: { enabled: false, html: "Privacy policy" },
    monthlyAnalysisOptOut: false,
    advanced: { customCss: "", customScript: "" },
  },
  checkout: {
    layout: "1",
    verificationMethod: "dob",
    instructionMessage:
      "Please confirm you are {{minimum_age}} years of age or older to continue.",
    dob: {
      dateFormat: "DD_MM_YYYY_SLASH",
      dateOrder: "DD,MM,YY",
      errorMessage:
        "You must be {{minimum_age}} or older. Please enter a valid date of birth.",
    },
    confirmCheckbox: {
      enabled: false,
      label: "I confirm I am {{minimum_age}}+",
      font: "'Inter', sans-serif",
      weight: "400",
      size: "15px",
      color: "#111827",
    },
    ageRule: { minAge: 18 },
    target: {
      mode: "always",
      selectedProducts: [],
      selectedCollections: [],
      productHandles: "",
      collectionHandles: "",
    },
    /** When true, theme should render the checkout age verification block; set via "Add age verification block". */
    ageVerificationBlockEnabled: false,
  },
};

export function cloneDefaultConfig() {
  return JSON.parse(JSON.stringify(DEFAULT_AGE_TEMPLATE_CONFIG));
}
